module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/news.json
// module id = 313
// module chunks = 208863975630277